export const SET_USER = "SET_USER";
export const AUTHENTICATE_USER = "AUTHENTICATE_USER ";
